var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"app-logo"},[_c('span',{staticClass:"app-logo__help",style:({ fontSize: _vm.helpSize })},[_vm._v("helpme")]),_c('span',{staticClass:"app-logo__domain",class:{ 'app-logo__domain--dark': _vm.dark },style:({ fontSize: _vm.domainSize })},[_vm._v(".garden")])])
}
var staticRenderFns = []

export { render, staticRenderFns }